import { Box } from "../Box";
import { IBoxState } from "./IBoxState";
import { AudioController, Sfx } from "../../../../AudioController";
import { BoxDeathParticle } from "../../particles/BoxDeathParticle";
import { BatchedRenderer } from "three.quarks";
import { GameResourcesPackage } from "../../../../../resources/GameResourcesPackage";

export class BoxDisappearState implements IBoxState {
    private particle: BoxDeathParticle;
    public constructor(
        private readonly gameResources: GameResourcesPackage,
        private readonly box: Box,
        private readonly audioController: AudioController,
        private readonly particlesRenderer: BatchedRenderer,
    ) { }

    public async enter(_previousState: IBoxState): Promise<void> {
        if (this.box.health === 0) {
            this.audioController.playSfx(Sfx.CoinCollect);
            this.particle = new BoxDeathParticle(this.gameResources, this.particlesRenderer);
            this.particle.position.set(0, 0.5, -0.7);
            this.box.parent.add(this.particle);
            await this.particle.play();
        } 
    }

    public exit(): void {
    }

    public process(_dt: number): IBoxState {
        const scale = Math.max(this.box.scale.x - 0.05, 0);
        this.box.scale.set(scale, scale, scale);
        if(scale == 0) {
            return null;
        }
        return this;
    }

}